import moment from 'moment';

export const hasError = (error) => {
    const errorMessage = "Erro na API, por favor tente novamente.";

    if (error.data === "Fetch User") {
        return error.message;
    }

    if (!error) {
        console.error(`API ${error.config.url} não encontrada`);
        return errorMessage;
    }
    if (process.env.NODE_ENV === "development") {
        console.error(error.status, error.data.message);
    }
    if (error.data && error.data.message) {
        return error.data.message;
    }

    return errorMessage;
};

export const formatCurrencieValueBRL = (value) => {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
};


export const formatRemovePhoneMask = (value) => {
    return value.toString().replace('(', '').replace(')', '').replace(' ', '').replace('-', '').replace(' ', '');
};

export const formatDocument = (value) => {

    if (value.lenght > 11) {
        value = value.padStart(14, '0');
        value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else {
        value = value.padStart(11, '0');
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return value;
}

export const formatData = (value, currentFormat, expectedFormat) => {
    moment.locale('pt-br');
    return moment(value, currentFormat).format(expectedFormat);
};

export const formatCep = (value) => {
    value = value.padStart(8, '0');
    value = value.replace(/^(\d{5})(\d{3})/, '$1-$2');
    return value;
};

export const getNameInitials = (name) => {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

    let initials = [...name.matchAll(rgx)] || [];

    initials = (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();

    return initials;
}

export const validaCpfCnpj = (val) => {
    var v1 = 0;
    var v2 = 0;
    var p;
    var p1;
    var p2;
    var i = 1;
    var aux = false;

    if (val.length == 14) {
        var cpf = val.trim();

        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');
        cpf = cpf.split('');



        for (i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }


        for (i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
            v1 += cpf[i] * p;
        }

        v1 = ((v1 * 10) % 11);

        if (v1 == 10) {
            v1 = 0;
        }

        if (v1 != cpf[9]) {
            return false;
        }

        for (i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
            v2 += cpf[i] * p;
        }

        v2 = ((v2 * 10) % 11);

        if (v2 == 10) {
            v2 = 0;
        }

        if (v2 != cpf[10]) {
            return false;
        } else {
            return true;
        }
    } else if (val.length == 18) {
        var cnpj = val.trim();

        cnpj = cnpj.replace(/\./g, '');
        cnpj = cnpj.replace('-', '');
        cnpj = cnpj.replace('/', '');
        cnpj = cnpj.split('');


        for (i = 1; cnpj.length > i; i++) {
            if (cnpj[i - 1] != cnpj[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        for (i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
            if (p1 >= 2) {
                v1 += cnpj[i] * p1;
            } else {
                v1 += cnpj[i] * p2;
            }
        }

        v1 = (v1 % 11);

        if (v1 < 2) {
            v1 = 0;
        } else {
            v1 = (11 - v1);
        }

        if (v1 != cnpj[12]) {
            return false;
        }

        for (i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) {
            if (p1 >= 2) {
                v2 += cnpj[i] * p1;
            } else {
                v2 += cnpj[i] * p2;
            }
        }

        v2 = (v2 % 11);

        if (v2 < 2) {
            v2 = 0;
        } else {
            v2 = (11 - v2);
        }

        if (v2 != cnpj[13]) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

export const formatStringToLowerCase = (str) => {
    // Converte para minúsculas e substitui espaços por hífens
    return str.toLowerCase().replace(/\s+/g, '-');
}

export const truncateString = (inputString, maxLength) => {
    if (inputString.length > maxLength) {
        return inputString.substring(0, maxLength) + '...';
    }
    return inputString;
}

export const ActionGetIPAddress = async () => {
    return await fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
            return ip;
        });
}

export const formatFloatToReal = (value) => {
    return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
}

/**
 * Converte valor para número, aceitando formato BR (1.234,56) ou número/string (1234.56).
 * Retorna número com até 2 casas decimais para evitar erros de precisão.
 * @param {string|number} value - Valor em formato BR, número ou string numérica
 * @returns {number}
 */
export const parseNumberFromBrOrNumber = (value) => {
    if (value == null || value === "") return 0;
    if (typeof value === "number" && !Number.isNaN(value)) {
        return Math.round(value * 100) / 100;
    }
    const str = String(value).trim();
    if (!str) return 0;
    const hasComma = str.includes(",");
    const normalized = hasComma
        ? str.replace(/\./g, "").replace(",", ".")
        : str;
    const num = parseFloat(normalized, 10);
    return Number.isNaN(num) ? 0 : Math.round(num * 100) / 100;
}

export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const formatDateToDayMonthYear = (data) => {
    // Verificar se a data tem o formato completo (com horas, minutos, etc.)
    if (data.includes("T")) {
        const dataCompleta = new Date(data);
        const dia = String(dataCompleta.getDate()).padStart(2, '0');
        const mes = String(dataCompleta.getMonth() + 1).padStart(2, '0');
        const ano = dataCompleta.getFullYear();
        return `${dia}/${mes}/${ano}`;
    } else {
        // Se a data não tiver o formato completo, presumir que está no formato "yyyy-mm-dd"
        const partesData = data.split("-");
        const dia = partesData[2];
        const mes = partesData[1];
        const ano = partesData[0];
        return `${dia}/${mes}/${ano}`;
    }
}

export const getEaster = (year) => {
    const f = Math.floor;
    const G = year % 19;
    const C = f(year / 100);
    const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
    const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
    const day = I - ((year + f(year / 4) + I + 2 - C + f(C / 4)) % 7) + 28;
    const month = day > 31 ? 4 : 3;
    return moment(`${year}-${month}-${day > 31 ? day - 31 : day}`, "YYYY-M-D");
}

// Obter lista de feriados no Brasil para um determinado ano
export const getBrazilianHolidays = (year) => {
    const easter = getEaster(year);

    const holidays = [
        moment(`${year}-01-01`), // Confraternização Universal
        moment(`${year}-04-21`), // Tiradentes
        moment(`${year}-05-01`), // Dia do Trabalhador
        moment(`${year}-09-07`), // Independência
        moment(`${year}-10-12`), // Nossa Senhora Aparecida
        moment(`${year}-11-02`), // Finados
        moment(`${year}-11-15`), // Proclamação da República
        moment(`${year}-12-25`), // Natal
    ];

    holidays.push(easter.clone().subtract(47, "days")); // Carnaval
    holidays.push(easter.clone().subtract(2, "days")); // Sexta-feira Santa
    holidays.push(easter.clone().add(60, "days")); // Corpus Christi

    return holidays.map((date) => date.format("YYYY-MM-DD"));
}

export const isBusinessDay = (date, holidays) => {
    const dayOfWeek = moment(date).day();
    return dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays.includes(moment(date).format("YYYY-MM-DD"));
}